import React, { useEffect, useState } from 'react';
import { sort } from 'fast-sort'
import ODSDashboardScreen from '../../screen/ODSDashboard';
import { useScope, useUser } from "../SelectProjectCompanyContainer"
import Send from '../../core/communication';
import { ods } from '../../core/utils/ods/indicadores';

const ODSDashboardContainer = () => {
  const [dw, setDw] = useState([])
  const { scope, scopeType } = useScope()

  const loadData = async () => {
    const dw = await Send.get("/dw/data", `projects='${scope?.id}'&scopeType=${scopeType}`)
    setDw(dw)
  }

  useEffect(() => {
    loadData()
  }, [scope?.id])

  const onChange = (code, value) => {
    // setState(state => ({ ...state, [code]: value }))
  }

  const onSelectAll = (data) => {
    // setState(state => ({ ...state, ...data }))
  }

  const data = sort(ods).asc(u => u.odsIndex)

  return <ODSDashboardScreen dw={dw} values={{}} onChange={onChange} ods={data} />;
}

export default ODSDashboardContainer;